import { ComingSoon } from '../../components/ComingSoon';

export function AiQuotaPage(): React.JSX.Element {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-[#1E293B]">AI 工具额度</h1>
      <ComingSoon
        title="租户 AI 额度管理"
        description="需要接入 /api/admin/ai-quota 接口，展示和调整各门店的 AI 工具使用额度。"
      />
    </div>
  );
}
